import { render, staticRenderFns } from "./deliverData.vue?vue&type=template&id=053ce48b&scoped=true&"
import script from "./deliverData.vue?vue&type=script&lang=js&"
export * from "./deliverData.vue?vue&type=script&lang=js&"
import style0 from "./deliverData.vue?vue&type=style&index=0&id=053ce48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ce48b",
  null
  
)

component.options.__file = "deliverData.vue"
export default component.exports